export default function FormsIcon({
    style,
    fill="#E8E8E8",
}){
    return <svg style={style} width="23" height="27" viewBox="0 0 23 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.6569 25.5V7.68458C21.6569 7.10073 21.4017 6.54603 20.9584 6.16606L15.4931 1.48149C15.1306 1.17078 14.6689 1 14.1915 1H3C1.89543 1 1 1.89543 1 3V23.5C1 24.6046 1.89543 25.5 3 25.5H16.3284" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.84375 10.6074H11.5692" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.84375 16.3711H18.2947" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
}